import {signInTypes} from "./AuthActionsTypes/SignInActionsTypes";
import {removeUserSignInErrors, setUserSignInError} from "./AuthErrorsActions";
import axios from "axios";

export const requestUserSignIn = () => {
    return {
        type: signInTypes.SIGN_IN_REQUEST,
    };
};

export const successUserSignIn = (data) => {
    return {
        type: signInTypes.SIGN_IN_SUCCESS,
        accessToken: data.accessToken,
        verified: data.verified,
    };
};

export const failureUserSignIn = (data) => {
    return {
        type: signInTypes.SIGN_IN_FAILURE,
    };
};

export const userSignIn = (user) => {
    return (dispatch, getState) => {
        dispatch(removeUserSignInErrors());
        dispatch(requestUserSignIn());

        const USER_REGISTER_API = "https://api.scoutafrique.com/api/auth/login";

        return axios.post(USER_REGISTER_API, user).then(response => {
            const data = response.data;
            dispatch(successUserSignIn(data));

        }).catch(error => {

            dispatch(failureUserSignIn());
            dispatch(setUserSignInError(error));

            return Promise.reject(setUserSignInError(error));
        });
    };
};
